/* ===== AROMAZUR v30 — bloc « Choisissez votre formule » sur les fiches diffuseur =====
   Trois formules : appareil seul / appareil + 3 huiles / appareil + abonnement.
   Regles :
     - tous les prix affichent l'ancien prix barre + le prix promo courant ;
       si la promotion du site est desactivee, seul le prix normal s'affiche.
     - le format d'abonnement propose depend de la contenance de l'appareil.
     - le pack 3 x 20 ml n'est propose que sur les modeles grand public.        */
(function(){

  /* ---------------------------------------------------------------- *
   *  1. ABONNEMENTS DISPONIBLES DANS SHOPIFY                          *
   *  Pour ajouter un format : creez le produit dans Shopify puis      *
   *  renseignez son handle et son prix mensuel ci-dessous.            *
   * ---------------------------------------------------------------- */
  /* Prix valides le 6 aout 2026 : ceux de la grille d'abonnement de l'accueil.
     « ref » est le prix unitaire du meme flacon, il sert a afficher l'economie.
     Un format dont le produit Shopify n'existe pas encore se declare avec
     handle:null — il est alors simplement absent des fiches, sans rien casser. */
  var ABOS=[
    /* handles verifies le 6 aout 2026 sur la boutique : les fiches creees
       portent le suffixe « -aromazur ». Les anciennes fiches sans suffixe
       (26,00 € et 39,20 €) sont a archiver, elles font doublon.             */
    {fmt:'20 ml',  handle:'abonnement-mensuel-20-ml-aromazur',  prix: 19.90, ref: 24.99},
    {fmt:'50 ml',  handle:'abonnement-mensuel-50-ml-aromazur',  prix: 43.90, ref: 54.99},
    {fmt:'120 ml', handle:'abonnement-mensuel-120-ml-aromazur', prix: 79.90, ref: 99.99},
    {fmt:'500 ml', handle:'abonnement-mensuel-500-ml-aromazur', prix:159.90, ref:199.99}
  ];
  /* Le prix d'abonnement EST deja le prix avantage : la promotion du site ne
     s'y ajoute pas. Il reste donc identique quand vous coupez la promotion.      */
  var PROMO_SUR_ABO=false;

  var DUREE={'20 ml':'environ deux semaines','50 ml':'environ un mois',
             '120 ml':'environ deux mois','500 ml':'jusqu’à six mois'};

  /* ---------------------------------------------------------------- *
   *  2. LOGIQUE PAR APPAREIL                                          *
   *  formats d'abonnement coherents avec la contenance du reservoir   *
   * ---------------------------------------------------------------- */
  var FMT_ABO={
    'az-mini-diffuseur-d-huiles-parfumees':                                    ['20 ml','50 ml'],
    'az-diffuseur-de-parfum':                                                  ['50 ml','120 ml'],
    'az-diffuseur-de-parfum-professionnel-fixation-murale-ou-a-poser':         ['50 ml','120 ml'],
    'az-diffuseur-de-parfum-sans-fil-huiles-parfumees':                        ['50 ml','120 ml'],
    'az-diffuseur-de-parfum-enceinte-prenium':                                 ['50 ml','120 ml'],
    'az-diffuseur-de-parfum-professionnel-colonne-design-pour-grands-espaces': ['120 ml','500 ml'],
    'az-diffuseur-d-huiles-parfumees-professionnel':                           ['120 ml','500 ml']
  };
  /* diffuseur -> pack correspondant */
  var PACKS={
    'az-mini-diffuseur-d-huiles-parfumees':'az-pack-decouverte-mini-diffuseur',
    'az-diffuseur-de-parfum':'az-pack-decouverte-diffuseur-de-parfum',
    'az-diffuseur-de-parfum-sans-fil-huiles-parfumees':'az-pack-decouverte-diffuseur-de-parfum-sans-fil-huiles-parfumees',
    'az-diffuseur-de-parfum-enceinte-prenium':'az-pack-decouverte-diffuseur-de-parfum-enceinte-prenium-aromasound™'
  };
  /* le pack decouverte 3 x 20 ml n'a de sens que sur les modeles grand public :
     un appareil a reservoir de 500 ml ne se vend pas avec trois flacons de 20 ml */
  var AVEC_PACK=['az-mini-diffuseur-d-huiles-parfumees','az-diffuseur-de-parfum',
                 'az-diffuseur-de-parfum-professionnel-fixation-murale-ou-a-poser',
                 'az-diffuseur-de-parfum-sans-fil-huiles-parfumees',
                 'az-diffuseur-de-parfum-enceinte-prenium'];

  /* ---------------------------------------------------------------- *
   *  3. PRIX                                                          *
   * ---------------------------------------------------------------- */
  var PROMO=(window.AZ_PROMO_PCT||0)/100;
  /* meme arrondi que Shopify : la remise est tronquee au centime inferieur */
  function remise(p){ if(!PROMO) return p; var r=Math.floor(p*PROMO*100)/100; return Math.round((p-r)*100)/100; }
  function eur(n){ return n.toFixed(2).replace('.',',')+' €'; }

  /* Si Shopify fournit compare_at_price > price, price est DEJA le prix promo.
     Sinon seulement, la promo maison peut etre appliquee. Les montants ici sont
     en euros (les centimes Shopify sont normalises avant d'arriver ici). */
  var REF=Number(window.AZ_PROMO_REF_PCT||0);
  function infoPrix(price,compare,appareil){
    price=Number(price)||0; compare=Number(compare)||0;
    /* prix de reference (promo ciblee) : seulement pour l'appareil de la fiche,
       jamais pour les huiles ni les abonnements, et jamais de remise recalculee */
    if(appareil && !(compare>price) && REF>0 && REF<100) compare=Math.round(price/(1-REF/100)*100)/100;
    if(price>0 && compare>price) return {cat:compare,net:price,shopify:true};
    return {cat:price,net:(PROMO?remise(price):price),shopify:false};
  }
  function duoInfo(i){
    if(!i || !(i.net>0)) return '';
    if(i.cat>i.net) return '<s class="az-p-old">'+eur(i.cat)+'</s> <b class="az-p az-p-promo">'+eur(i.net)+'</b>';
    return '<b class="az-p">'+eur(i.net)+'</b>';
  }
  /* Compatibilite avec les donnees statiques du theme, qui n'ont pas de
     compare_at_price : elles continuent de recevoir la promo maison. */
  function duo(cat){ return duoInfo(infoPrix(cat,0)); }

  function $(s,r){ return (r||document).querySelector(s); }
  function esc(s){ return String(s==null?'':s).replace(/[&<>"]/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c];}); }
  /* Panier natif Shopify (08/09/2026) : chaque ligne part dans /cart/add.js via
     assets/az-cart.js. Renvoie une promesse ; le tiroir s'ouvre a la fin. */
  function ajoute(l){ return window.AZCart ? AZCart.addLegacy(l) : Promise.reject(new Error('panier indisponible')); }
  function total(c){ return (c&&c.item_count)||0; }

  function huiles(DB){
    return Object.keys(DB).map(function(k){return DB[k];})
      .filter(function(p){return p.type==='huile';})
      .sort(function(a,b){return a.title.localeCompare(b.title);});
  }
  /* Prix d'un flacon d'un format donne. Quand Shopify expose un
     compare_at_price, on le conserve pour ne pas remiser deux fois. */
  function prixFormatInfo(hu,fmt){
    var cible=fmt.replace(/\s/g,'').toLowerCase(), i;
    var reel=window.AZ_OIL_PRICES, comp=window.AZ_OIL_COMPARE_PRICES;
    if(reel){ var k=Object.keys(reel);
      for(i=0;i<k.length;i++){
        if(k[i].replace(/\s/g,'').toLowerCase()===cible && typeof reel[k[i]]==='number')
          return {price:reel[k[i]],compare:(comp&&typeof comp[k[i]]==='number')?comp[k[i]]:0};
      }
    }
    /* Repli : base statique az-db.js. Pas de compare_at_price connu ici, donc
       la promo maison reste applicable comme avant. */
    if(!hu.length) return null;
    var v=hu[0].variants;
    for(i=0;i<v.length;i++)
      if(String(v[i].title).replace(/\s/g,'').toLowerCase()===cible)
        return {price:v[i].price,compare:Number(v[i].compare_at_price||0)};
    return null;
  }

  /* Prix reel de l'appareil injecte par Shopify dans #ppVariants. */
  function prixAppareilInfo(p){
    try{
      var n=document.getElementById('ppVariants');
      if(n){
        var vs=JSON.parse(n.textContent||'[]'), best=null;
        for(var i=0;i<vs.length;i++){
          var pr=Number(vs[i].price); if(!(pr>0)) continue;
          if(vs[i].available===false) continue;
          if(!best || pr<best.price){
            best={price:pr,compare:Number(vs[i].compare_at_price||0)};
          }
        }
        if(best) return {price:best.price/100,compare:best.compare/100};
      }
    }catch(e){}
    return {price:p.variants[0].price,compare:Number(p.variants[0].compare_at_price||0)};
  }
  /* ---------------------------------------------------------------- *
   *  SELECTEUR VISUEL D'HUILES — vignettes defilantes                 *
   *  reprend le principe du selecteur des anciennes bulles :          *
   *  image + nom + famille, selection par clic, compteur.             *
   * ---------------------------------------------------------------- */
  var CHOIX={pack:[],abo:[]};window.AZ_CHOIX=CHOIX;   /* handles retenus, dans l'ordre de selection */

  function vignette(o){
    return '<button type="button" class="az-h" data-h="'+esc(o.handle)+'" title="'+esc(o.title)+
      (o.notes?' — '+esc(o.notes):'')+'">'+
      '<span class="az-h-n"></span>'+
      '<span class="az-h-i">'+(o.images&&o.images[0]?'<img src="'+esc(o.images[0])+'" alt="" loading="lazy">':'')+'</span>'+
      '<span class="az-h-t">'+esc(o.title.replace(/^Huile\s+/i,''))+'</span>'+
      (o.family?'<span class="az-h-f"'+(o.famhex?' style="color:'+esc(o.famhex)+'"':'')+'>'+esc(o.family)+'</span>':'')+
      '</button>';
  }

  function selecteur(liste,n,id){
    var fams=[]; liste.forEach(function(o){ if(o.family&&fams.indexOf(o.family)<0) fams.push(o.family); });
    var filtres='<span class="az-fam"><button type="button" class="az-fam-b on" data-fam="">Toutes</button>'+
      fams.map(function(f){ return '<button type="button" class="az-fam-b" data-fam="'+esc(f)+'">'+esc(f)+'</button>'; }).join('')+'</span>';
    return '<span class="az-oils" data-for="'+id+'" data-max="'+n+'">'+
      '<span class="az-oils-h">'+(n>1?'Choisissez vos <b>'+n+' signatures</b>':'Choisissez votre signature')+
        '<span class="az-cnt" data-cnt="'+id+'">0/'+n+'</span></span>'+
      filtres+
      '<span class="az-scroll-w">'+
        '<button type="button" class="az-nav az-nav-l" data-dir="-1" aria-label="Précédent">‹</button>'+
        '<span class="az-scroll">'+liste.map(vignette).join('')+'</span>'+
        '<button type="button" class="az-nav az-nav-r" data-dir="1" aria-label="Suivant">›</button>'+
      '</span>'+
      '<span class="az-choisies" data-sel="'+id+'"></span>'+
      '</span>';
  }

  /* ---------------------------------------------------------------- *
   *  4. CONSTRUCTION DU BLOC                                          *
   * ---------------------------------------------------------------- */
  function boot(){
    var DB=window.AZ_DB, sh=window.AZ_PRODUCT_HANDLE;
    if(!DB||!sh) return;
    var h='az-'+sh, p=DB[h];
    if(!p) return;
    var form=$('#ppForm'); if(!form) return;
    if(p.type==='pack'){ bootPack(DB,p,form); return; }
    if(p.type!=='diffuseur') return;

    var hu=huiles(DB);
    var brutDiff=prixAppareilInfo(p);
    var prixDiff=infoPrix(brutDiff.price,brutDiff.compare,true);
    var catDiff=prixDiff.cat, netDiff=prixDiff.net;

    /* abonnements pertinents pour cet appareil, limites a ceux qui existent */
    var voulus=FMT_ABO[h]||['50 ml','120 ml'];
    var dispo=ABOS.filter(function(a){ return a.handle&&a.prix&&voulus.indexOf(a.fmt)>=0; });
    if(!dispo.length) dispo=ABOS.filter(function(a){ return a.handle&&a.prix; }).slice(0,1);

    var html='<div class="az-offres"><div class="az-offres-t">Choisissez votre formule</div>';

    /* ---- 1. l'appareil seul ---- */
    html+='<label class="az-opt on" data-o="seul"><input type="radio" name="azoffre" value="seul" checked>'+
      '<span class="az-opt-c"><span class="az-opt-h"><b>Le diffuseur seul</b><em>'+duoInfo(prixDiff)+'</em></span>'+
      '<span class="az-opt-s">Livré sans huile — à compléter avec la signature de votre choix.</span>'+
      '</span></label>';

    /* ---- 2. l'appareil + 3 huiles ---- */
    var pk=(AVEC_PACK.indexOf(h)>=0 && PACKS[h]) ? DB[PACKS[h]] : null;
    if(pk){
      var prixPack=infoPrix(pk.variants[0].price,pk.variants[0].compare_at_price||0);
      var catPack=prixPack.cat, netPack=prixPack.net;
      var brut20=prixFormatInfo(hu,'20 ml');
      var prix20=brut20?infoPrix(brut20.price,brut20.compare):{cat:0,net:0};
      var cat20=prix20.cat, net20=prix20.net;
      var supplement=Math.round((netPack-netDiff)*100)/100;   /* ce qu'il paie en plus */
      var valeur=Math.round((netDiff+3*net20)*100)/100;       /* la meme chose achetee separement */
      var gain=Math.round((valeur-netPack)*100)/100;
      var pct=valeur>0?Math.round(gain/valeur*100):0;
      html+='<label class="az-opt az-best" data-o="pack"><input type="radio" name="azoffre" value="pack">'+
        '<span class="az-opt-c">'+
        '<span class="az-offre-badge">Meilleure valeur</span>'+
        '<span class="az-opt-h"><b>Avec 3 huiles au choix</b><em>'+duoInfo(prixPack)+'</em></span>'+
        '<span class="az-opt-s"><b>+ '+eur(supplement)+' seulement</b> pour trois flacons de 20 ml, '+
          'qui valent '+eur(3*net20)+' achetés séparément.</span>'+
        (gain>0?'<span class="az-gain">Vous économisez '+eur(gain)+' <i>soit '+pct+' % sur l’ensemble</i></span>':'')+
        selecteur(hu,3,'pack')+'</span></label>';
    }

    /* ---- 3. l'appareil + abonnement huile ---- */
    if(dispo.length){
      var choixFmt='';
      if(dispo.length>1){
        choixFmt='<span class="az-fmt"><span class="az-fmt-l">Format du flacon</span>'+
          dispo.map(function(a,i){
            return '<button type="button" class="az-fmt-b'+(i===0?' on':'')+'" data-fmt="'+esc(a.fmt)+'">'+esc(a.fmt)+'</button>';
          }).join('')+'</span>';
      }
      html+='<label class="az-opt" data-o="abo"><input type="radio" name="azoffre" value="abo">'+
        '<span class="az-opt-c">'+
        '<span class="az-opt-h"><b>Avec un abonnement huile</b><em id="azAboPrix"></em></span>'+
        '<span class="az-opt-s" id="azAboTxt"></span>'+
        choixFmt+
        '<span class="az-gain" id="azAboGain"></span>'+
        /* Ne promettre ici que ce que les CGV tiennent : la garantie commerciale
           de l'appareil est d'UN an (article 7 des CGV). Une mention affichee
           avant l'achat prime sur des CGV plus restrictives : annoncer 2 ans
           creerait un engagement contractuel que vous n'assumez pas.        */
        '<span class="az-opt-plus">Sans engagement · résiliable à tout moment · livraison incluse</span>'+
        selecteur(hu,1,'abo')+'</span></label>';
    }

    html+='<div class="az-offres-err" id="azOffreErr"></div>'+
          '<button type="button" class="az-offres-add" id="azOffreAdd">Ajouter au panier</button>'+
          '<div class="az-offres-ok" id="azOffreOk"></div></div>';

    /* on masque la quantite et le bouton standard, mais on GARDE le choix
       du coloris, qui vit dans le meme formulaire */
    var q=form.querySelector('.pp-qty'); if(q) q.style.display='none';
    var add=$('#ppAdd'); if(add) add.style.display='none';

    var box=document.createElement('div'); box.innerHTML=html;
    form.parentNode.insertBefore(box.firstChild, form.nextSibling);

    var root=$('.az-offres');
    var fmtActif=dispo.length?dispo[0]:null;

    /* ---- verification des abonnements reellement publies dans Shopify ------
       Le bloc affiche les formats declares en tete de ce fichier. Si le produit
       d'abonnement correspondant n'existe pas encore, ou si son prix a ete
       change dans Shopify, l'affichage mentirait et l'ajout au panier
       echouerait au moment du paiement. On interroge donc Shopify a la demande,
       la premiere fois que le client ouvre l'option, et on corrige :
         produit absent  -> le format disparait (et l'option entiere si aucun
                            format ne subsiste) ;
         prix different  -> c'est le prix Shopify qui fait foi, jamais le code.
       En cas d'echec reseau on ne touche a rien : on garde l'affichage code.
       Une seule requete par format et par onglet (mise en cache de session). */
    var verifFaite=false;
    function verifieAbos(){
      if(verifFaite || !dispo.length || typeof fetch!=='function') return;
      verifFaite=true;
      dispo.slice().forEach(function(a){
        var cle='azabo:'+a.handle, cache=null;
        try{ cache=sessionStorage.getItem(cle); }catch(e){}
        if(cache!==null){ applique(a,cache); return; }
        fetch('/products/'+a.handle+'.js',{credentials:'same-origin'})
          .then(function(r){
            /* seul un vrai 404 signifie « ce produit n'existe pas ». Une panne
               passagere (500, 502, coupure reseau) ne doit surtout pas faire
               disparaitre l'offre : dans le doute on garde l'affichage code. */
            if(r.status===404) return 'absent';
            if(!r.ok) return null;
            return r.json().then(function(j){ return (j&&j.price!=null)?String(j.price):null; });
          })
          .then(function(val){
            if(val===null||val===undefined) return;
            try{ sessionStorage.setItem(cle,val); }catch(e){}
            applique(a,val);
          })
          .catch(function(){});
      });
    }
    function applique(a,val){
      if(val==='absent'){ retire(a); return; }
      var p=parseInt(val,10)/100;
      if(p>0 && Math.abs(p-a.prix)>0.005){ a.prix=p; if(fmtActif===a) majAbo(); }
    }
    function retire(a){
      var i=dispo.indexOf(a); if(i<0) return;
      dispo.splice(i,1);
      var b=root.querySelector('.az-fmt-b[data-fmt="'+a.fmt+'"]');
      if(b&&b.parentNode) b.parentNode.removeChild(b);
      var lab=root.querySelector('.az-opt[data-o="abo"]');
      if(!dispo.length){
        if(lab){ lab.style.display='none';
          var r=lab.querySelector('input[name=azoffre]');
          if(r&&r.checked){ var a1=root.querySelector('.az-opt:not([style*="none"]) input[name=azoffre]');
                            if(a1){ a1.checked=true; maj(); } }
        }
        fmtActif=null; return;
      }
      if(dispo.length===1){ var z=root.querySelector('.az-fmt'); if(z) z.style.display='none'; }
      if(fmtActif===a){
        fmtActif=dispo[0];
        root.querySelectorAll('.az-fmt-b').forEach(function(x,k){ x.classList.toggle('on',k===0); });
        majAbo();
      }
    }

    function majAbo(){
      if(!fmtActif) return;
      var brutFmt=prixFormatInfo(hu,fmtActif.fmt);
      var prixFmt=brutFmt?infoPrix(brutFmt.price,brutFmt.compare):null;
      var catFmt=prixFmt?prixFmt.cat:null;
      var netFmt=prixFmt?prixFmt.net:null;             /* prix unitaire paye aujourd'hui */
      var prixAbo=PROMO_SUR_ABO?remise(fmtActif.prix):fmtActif.prix;
      var ec = (netFmt!=null) ? Math.round((netFmt-prixAbo)*100)/100 : 0;
      /* L'abonnement fait-il vraiment economiser AUJOURD'HUI, face au prix
         effectivement paye ce jour ? Pendant la promotion du site, non : les
         deux prix se rejoignent. Le bloc bascule alors d'un discours de prix
         vers un discours de garantie de prix. Il revient tout seul au discours
         d'economie le jour ou la promotion s'arrete, sans intervention. */
      var argent = (ec >= 1.5);
      /* Prix barre : seulement quand l'ecart est reel. Barrer 54,99 € pendant
         que le flacon est vendu 44,00 € depuis des semaines serait un prix de
         reference contestable au regard de la regle Omnibus (le prix de
         reference doit etre le prix le plus bas des 30 derniers jours). */
      /* Le prix de reference affiche est le prix catalogue REEL du flacon lu
         sur Shopify (catFmt). La valeur « ref » codee en tete de fichier ne
         sert plus que de filet si Shopify n'a rien renvoye : sans cela le
         barre et le prix a l'unite pourraient se contredire. */
      var refUnit = (catFmt!=null) ? catFmt : fmtActif.ref;
      var mois = (argent && refUnit && refUnit>prixAbo)
        ? '<s class="az-p-old">'+eur(refUnit)+'</s> <b class="az-p az-p-promo">'+eur(prixAbo)+'</b>/mois'
        : '<b class="az-p">'+eur(prixAbo)+'</b>/mois';
      $('#azAboPrix').innerHTML=duoInfo(prixDiff)+' <span class="az-plus">+ '+mois+'</span>';
      $('#azAboTxt').innerHTML='Un flacon de '+esc(fmtActif.fmt)+' livré chaque mois — '+
        (DUREE[fmtActif.fmt]||'')+' de diffusion, le format adapté à la contenance de cet appareil.';
      var g=$('#azAboGain');
      if(argent){
        var pc=Math.round(ec/netFmt*100);
        g.innerHTML='Vous économisez '+eur(ec)+' <i>par flacon, soit '+pc+' % — le '+esc(fmtActif.fmt)+
                    ' est à '+eur(netFmt)+' à l’unité</i>';
      } else {
        /* argument valable pendant la promotion : le prix de l'abonnement est
           fixe, celui du flacon a l'unite va remonter a la fin de l'operation */
        g.innerHTML='Tarif garanti '+eur(prixAbo)+'/mois <i>· la promotion sur les flacons à l’unité est temporaire'+
                    (refUnit?' — le '+esc(fmtActif.fmt)+' revient ensuite à '+eur(refUnit):'')+
                    ' · livraison incluse · parfum modifiable chaque mois</i>';
      }
      g.style.display='';
    }

    function maj(){
      var v=(root.querySelector('input[name=azoffre]:checked')||{}).value;
      root.querySelectorAll('.az-opt').forEach(function(l){ l.classList.toggle('on', l.getAttribute('data-o')===v); });
      /* attention : mettre display='' rendrait la main a la feuille de style,
         qui declare .az-oils{display:none} — il faut une valeur explicite */
      root.querySelectorAll('.az-oils').forEach(function(d){ d.style.display=(d.getAttribute('data-for')===v)?'block':'none'; });
      $('#azOffreErr').textContent='';
      if(v==='abo') verifieAbos();   /* on ne verifie Shopify que si on ouvre l'offre */
    }
    root.addEventListener('change',maj);

    /* ---- selecteur visuel d'huiles : selection, filtres, defilement ---- */
    function titrePour(hd){ var o=DB[hd]; return o?o.title:hd; }
    function majChoix(id){
      var box=root.querySelector('.az-oils[data-for="'+id+'"]'); if(!box) return;
      var max=parseInt(box.getAttribute('data-max'),10)||1, sel=CHOIX[id]||[];
      box.querySelectorAll('.az-h').forEach(function(b){
        var i=sel.indexOf(b.getAttribute('data-h'));
        b.classList.toggle('sel',i>=0);
        b.classList.toggle('bloque', i<0 && sel.length>=max);
        b.querySelector('.az-h-n').textContent = i>=0 ? (max>1?(i+1):'✓') : '';
      });
      var c=box.querySelector('.az-cnt'); if(c){ c.textContent=sel.length+'/'+max; c.classList.toggle('ok',sel.length===max); }
      var r=box.querySelector('.az-choisies');
      if(r) r.innerHTML = sel.length
        ? sel.map(function(x){ return '<span class="az-tag">'+esc(titrePour(x))+'<i data-del="'+esc(x)+'">×</i></span>'; }).join('')
        : '';
    }
    root.addEventListener('click',function(e){
      var t=e.target, cl=function(s){ return t.closest?t.closest(s):null; };

      /* format d'abonnement */
      var bf=cl('.az-fmt-b');
      if(bf){
        e.preventDefault();
        var f=bf.getAttribute('data-fmt');
        for(var i=0;i<dispo.length;i++) if(dispo[i].fmt===f) fmtActif=dispo[i];
        root.querySelectorAll('.az-fmt-b').forEach(function(x){ x.classList.toggle('on',x===bf); });
        var rb=root.querySelector('input[value=abo]'); if(rb&&!rb.checked) rb.checked=true;
        maj(); majAbo(); return;
      }

      /* retrait d'une signature depuis la pastille recapitulative */
      if(t.hasAttribute&&t.hasAttribute('data-del')){
        e.preventDefault(); e.stopPropagation();
        var box=cl('.az-oils'), id=box.getAttribute('data-for'), hd=t.getAttribute('data-del');
        var k=CHOIX[id].indexOf(hd); if(k>=0) CHOIX[id].splice(k,1);
        majChoix(id); $('#azOffreErr').textContent=''; return;
      }

      /* filtre par famille olfactive */
      var bfam=cl('.az-fam-b');
      if(bfam){
        e.preventDefault(); e.stopPropagation();
        var zone=cl('.az-oils'), fam=bfam.getAttribute('data-fam');
        zone.querySelectorAll('.az-fam-b').forEach(function(x){ x.classList.toggle('on',x===bfam); });
        zone.querySelectorAll('.az-h').forEach(function(b){
          var o=DB[b.getAttribute('data-h')];
          b.style.display=(!fam||(o&&o.family===fam))?'':'none';
        });
        var sc=zone.querySelector('.az-scroll'); if(sc) sc.scrollLeft=0;
        return;
      }

      /* fleches de defilement */
      var bn=cl('.az-nav');
      if(bn){
        e.preventDefault(); e.stopPropagation();
        var s=cl('.az-scroll-w').querySelector('.az-scroll');
        s.scrollBy({left:parseInt(bn.getAttribute('data-dir'),10)*s.clientWidth*0.8,behavior:'smooth'});
        return;
      }

      /* selection d'une huile */
      var bh=cl('.az-h');
      if(bh){
        e.preventDefault(); e.stopPropagation();
        var zb=cl('.az-oils'), zid=zb.getAttribute('data-for');
        var zmax=parseInt(zb.getAttribute('data-max'),10)||1, hd2=bh.getAttribute('data-h');
        var arr=CHOIX[zid], j=arr.indexOf(hd2);
        if(j>=0) arr.splice(j,1);
        else if(zmax===1) CHOIX[zid]=[hd2];
        else if(arr.length<zmax) arr.push(hd2);
        else { $('#azOffreErr').textContent='Vous avez déjà choisi '+zmax+' signatures — retirez-en une pour changer.'; majChoix(zid); return; }
        majChoix(zid); $('#azOffreErr').textContent='';
        return;
      }
    });
    majAbo(); maj(); majChoix('pack'); majChoix('abo');

    /* variante reellement selectionnee (coloris) */
    function variante(){
      var el=$('#ppVariantId'), id=el?parseInt(el.value,10):NaN;
      /* Priorite aux donnees Shopify de la page : elles portent le vrai price et
         le compare_at_price. On normalise ici les centimes en euros. */
      try{
        var n=document.getElementById('ppVariants'), vs=n?JSON.parse(n.textContent||'[]'):[];
        for(var i=0;i<vs.length;i++) if(parseInt(vs[i].id,10)===id)
          return {id:vs[i].id,title:vs[i].title||'',price:Number(vs[i].price||0)/100,
                  compare_at_price:Number(vs[i].compare_at_price||0)/100};
      }catch(e){}
      for(var j=0;j<p.variants.length;j++) if(p.variants[j].id===id) return p.variants[j];
      return p.variants[0];
    }

    $('#azOffreAdd').addEventListener('click',function(){
      var v=(root.querySelector('input[name=azoffre]:checked')||{}).value;
      var err=$('#azOffreErr'), vr=variante(), btn=$('#azOffreAdd'), lab=btn.textContent;
      var prixVr=infoPrix(vr.price,vr.compare_at_price||0,true);
      var ligneDiff={key:h+'|'+vr.id,handle:h,fmtIdx:0,q:1,title:p.title,fmt:vr.title||'',
                     price:prixVr.net,img:p.images[0]||'',oils:null};
      var suite;
      if(v==='seul'){
        suite=ajoute(ligneDiff);
      } else {
        var zone=root.querySelector('.az-oils[data-for="'+v+'"]');
        var need=parseInt(zone.getAttribute('data-max'),10)||1;
        var vals=(CHOIX[v]||[]).map(titrePour);
        if(vals.length!==need){
          err.textContent = need>1
            ? 'Choisissez vos '+need+' signatures — il en manque '+(need-vals.length)+'.'
            : 'Choisissez votre signature.';
          zone.scrollIntoView({behavior:'smooth',block:'center'});
          return;
        }
        if(v==='pack'){
          var ph=PACKS[h], pkv=pk.variants[0];
          for(var i=0;i<pk.variants.length;i++)
            if(String(pk.variants[i].title).toLowerCase()===String(vr.title).toLowerCase()) pkv=pk.variants[i];
          var prixPkv=infoPrix(pkv.price,pkv.compare_at_price||0);
          suite=ajoute({key:ph+'|'+pkv.id+'|'+vals.join(','),handle:ph,fmtIdx:0,q:1,title:pk.title,
                    fmt:pkv.title||'',price:prixPkv.net,img:pk.images[0]||'',oils:vals});
        } else {
          var pa=PROMO_SUR_ABO?remise(fmtActif.prix):fmtActif.prix;
          /* diffuseur d'abord, puis l'abonnement — en sequence, un seul tiroir ouvert a la fin */
          suite=AZCart.addLegacy(ligneDiff).then(function(){
            return ajoute({key:fmtActif.handle+'|'+fmtActif.fmt+'|'+vals[0],handle:fmtActif.handle,fmtIdx:0,q:1,
                    title:'Abonnement '+vals[0],fmt:fmtActif.fmt+' · mensuel',price:pa,
                    img:p.images[0]||'',oils:null,isAbo:true});
          });
        }
      }
      btn.disabled=true; btn.textContent='Ajout…'; err.textContent='';
      suite.then(function(c){
        var ok=$('#azOffreOk');
        ok.innerHTML='<strong>✓ Ajouté au panier</strong><span>'+total(c)+' article'+(total(c)>1?'s':'')+'</span>'+
                     '<button type="button" onclick="AZCart.open()">Voir mon panier</button>';
        ok.style.display='block';
      }).catch(function(e){
        err.textContent = (e&&e.message&&/rupture|stock/i.test(e.message)) ? e.message
          : 'Cet article ne peut pas être ajouté pour le moment. Écrivez-nous à contact@aromazur.fr.';
      }).then(function(){ btn.disabled=false; btn.textContent=lab; });
    });
  }

  /* ---------------------------------------------------------------- *
   *  5. FICHE D'UN PACK « diffuseur + 3 huiles au choix » (09/09/2026) *
   *  Jusqu'ici, la fiche d'un pack ajoutait le pack SANS demander les  *
   *  trois signatures : la commande partait incomplete et il fallait   *
   *  recontacter le client. Le meme selecteur defilant que sur les     *
   *  fiches diffuseur est donc affiche ici, et l'ajout est refuse tant  *
   *  que les trois huiles ne sont pas choisies.                        *
   * ---------------------------------------------------------------- */
  function bootPack(DB,p,form){
    if(!/huiles?\s+au\s+choix|3\s*huiles/i.test(p.title||'') && !/pack-decouverte/.test(p.handle||'')) return;
    if(p.requires_selling_plan) return;
    var hu=huiles(DB); if(!hu.length) return;
    var N=3, html='<div class="az-offres az-offres-pack"><div class="az-offres-t">Composez votre pack</div>'+
      '<div class="az-opt on" data-o="pack" style="padding-left:15px;cursor:default">'+selecteur(hu,N,'pack')+'</div>'+
      '<div class="az-offres-err" id="azOffreErr"></div>'+
      '<button type="button" class="az-offres-add" id="azOffreAdd">Ajouter au panier</button>'+
      '<div class="az-offres-ok" id="azOffreOk"></div></div>';
    var q=form.querySelector('.pp-qty'); if(q) q.style.display='none';
    var add=$('#ppAdd'); if(add) add.style.display='none';
    var box=document.createElement('div'); box.innerHTML=html;
    form.parentNode.insertBefore(box.firstChild, form.nextSibling);
    var root=$('.az-offres'), zone=root.querySelector('.az-oils'); zone.style.display='block';
    CHOIX.pack=[];
    function titrePour(hd){ var o=DB[hd]; return o?o.title:hd; }
    function majChoix(){
      var sel=CHOIX.pack;
      zone.querySelectorAll('.az-h').forEach(function(b){
        var i=sel.indexOf(b.getAttribute('data-h'));
        b.classList.toggle('sel',i>=0);
        b.classList.toggle('bloque', i<0 && sel.length>=N);
        b.querySelector('.az-h-n').textContent = i>=0 ? (i+1) : '';
      });
      var c=zone.querySelector('.az-cnt'); if(c){ c.textContent=sel.length+'/'+N; c.classList.toggle('ok',sel.length===N); }
      var r=zone.querySelector('.az-choisies');
      if(r) r.innerHTML = sel.length ? sel.map(function(x){ return '<span class="az-tag">'+esc(titrePour(x))+'<i data-del="'+esc(x)+'">×</i></span>'; }).join('') : '';
    }
    root.addEventListener('click',function(e){
      var t=e.target, cl=function(sl){ return t.closest?t.closest(sl):null; };
      if(t.hasAttribute&&t.hasAttribute('data-del')){
        e.preventDefault(); e.stopPropagation();
        var k=CHOIX.pack.indexOf(t.getAttribute('data-del')); if(k>=0) CHOIX.pack.splice(k,1);
        majChoix(); $('#azOffreErr').textContent=''; return;
      }
      var bfam=cl('.az-fam-b');
      if(bfam){
        e.preventDefault(); e.stopPropagation();
        var fam=bfam.getAttribute('data-fam');
        zone.querySelectorAll('.az-fam-b').forEach(function(x){ x.classList.toggle('on',x===bfam); });
        zone.querySelectorAll('.az-h').forEach(function(b){ var o=DB[b.getAttribute('data-h')]; b.style.display=(!fam||(o&&o.family===fam))?'':'none'; });
        var sc=zone.querySelector('.az-scroll'); if(sc) sc.scrollLeft=0;
        return;
      }
      var bn=cl('.az-nav');
      if(bn){
        e.preventDefault(); e.stopPropagation();
        var sc2=cl('.az-scroll-w').querySelector('.az-scroll');
        sc2.scrollBy({left:parseInt(bn.getAttribute('data-dir'),10)*sc2.clientWidth*0.8,behavior:'smooth'});
        return;
      }
      var bh=cl('.az-h');
      if(bh){
        e.preventDefault(); e.stopPropagation();
        var hd=bh.getAttribute('data-h'), arr=CHOIX.pack, j=arr.indexOf(hd);
        if(j>=0) arr.splice(j,1);
        else if(arr.length<N) arr.push(hd);
        else { $('#azOffreErr').textContent='Vous avez déjà choisi '+N+' signatures — retirez-en une pour changer.'; majChoix(); return; }
        majChoix(); $('#azOffreErr').textContent='';
      }
    });
    majChoix();
    $('#azOffreAdd').addEventListener('click',function(){
      var err=$('#azOffreErr'), btn=$('#azOffreAdd'), lab=btn.textContent;
      var vals=CHOIX.pack.map(titrePour);
      if(vals.length!==N){
        err.textContent='Choisissez vos '+N+' signatures — il en manque '+(N-vals.length)+'.';
        zone.scrollIntoView({behavior:'smooth',block:'center'}); return;
      }
      var el=$('#ppVariantId'), id=el?parseInt(el.value,10):NaN;
      if(!id||!window.AZCart){ err.textContent='Cet article ne peut pas être ajouté pour le moment. Écrivez-nous à contact@aromazur.fr.'; return; }
      var qte=1, qi=form.querySelector('#ppQty'); if(qi&&parseInt(qi.value,10)>0) qte=parseInt(qi.value,10);
      btn.disabled=true; btn.textContent='Ajout…'; err.textContent='';
      AZCart.add({id:id,quantity:qte,properties:{'Huiles choisies':vals.join(', ')}}).then(function(c){
        var ok=$('#azOffreOk');
        ok.innerHTML='<strong>✓ Ajouté au panier</strong><span>'+total(c)+' article'+(total(c)>1?'s':'')+'</span>'+
                     '<button type="button" onclick="AZCart.open()">Voir mon panier</button>';
        ok.style.display='block';
      }).catch(function(e){
        err.textContent = (e&&e.message&&/rupture|stock/i.test(e.message)) ? e.message
          : 'Cet article ne peut pas être ajouté pour le moment. Écrivez-nous à contact@aromazur.fr.';
      }).then(function(){ btn.disabled=false; btn.textContent=lab; });
    });
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',boot); else boot();
})();
